import { useMutation, useQueryClient } from "@tanstack/react-query";
import { XIcon } from "lucide-react";

import { Button } from "@/components/base/button";
import { useAppForm } from "@/components/base/form";
import { useTRPC } from "@/integrations/trpc/react";

export type RemoveDivisionFormProps = {
  tournamentId: number;
  divisionId: number;
  isDisabled?: boolean;
};

export function RemoveDivisionForm({
  tournamentId,
  divisionId,
  isDisabled,
}: RemoveDivisionFormProps) {
  const queryClient = useQueryClient();
  const trpc = useTRPC();

  const { mutate, failureReason } = useMutation({
    ...trpc.tournaments.removeDivision.mutationOptions(),
    onSuccess: () => {
      queryClient.invalidateQueries(trpc.tournaments.pathFilter());
    },
  });

  const form = useAppForm({
    defaultValues: {
      id: divisionId,
    },
    onSubmit: ({ value: { id } }) => {
      if (!isDisabled) {
        mutate({
          id,
        });
      }
    },
  });

  return (
    <form
      className="flex flex-col space-y-3"
      onSubmit={(e) => {
        e.preventDefault();

        form.handleSubmit();
      }}
    >
      <form.AppForm>
        <form.ConfirmSubmitButton
          isDisabled={isDisabled}
          size="sm"
          description="Removing a division will delete any data related to this division such as teams and matches."
          requireChange={false}
        >
          <XIcon size={12} /> Remove
        </form.ConfirmSubmitButton>
      </form.AppForm>
    </form>
  );
}
